import type { ContactChannel, NavItem, SocialLink } from '@/types/content'
import { ROUTES, asset, download } from '@/lib/paths'

/** Identity, contact details and global copy. */
export const site = {
  name: 'Kris Ella',
  owner: 'Kris David Steeve Ella',
  role: 'Digital Engineer — UI/UX Designer & Full-Stack Developer',
  /* Kept short: at the current display sizes a longer line makes the hero
     card tower over the panel beside it. */
  tagline:
    'Digital Engineer. I design and ship products end to end — UI/UX, full-stack, and the cloud that runs them.',
  bio: 'I am Kris David Steeve Ella, a graduated Digital Engineering Engineer passionate about digital systems. I specialise in UI/UX design, digital networking and telecommunications, as well as cloud computing and DevOps. My enthusiasm for technology drives me to pursue excellence in every aspect of my work and all the bright discoveries it entails.',
  mark: asset('brand/mark.png'),
  portrait: asset('portraits/portrait.jpg'),
  /** Wide blue hero frame — used as the social share card. */
  heroImage: asset('portraits/hero.jpg'),
  /**
   * The CV, as a direct file link.
   *
   * Served from Cloudinary like every other piece of media, so uploading a
   * new one in the admin panel replaces it with no deploy — a CV changes far
   * more often than the code does, and needing a release to update it is how
   * a portfolio ends up advertising last year's roles.
   */
  resume: download('documents/kris-ella-cv.pdf'),
  email: 'ellakrisdavidsteeve@gmail.com',
  location: 'Yaoundé, Cameroon',
  /**
   * Where `location` actually is, so the contact map cannot drift from the
   * text beside it. It had: the map was still showing the template's
   * Amsterdam coordinates under a heading that said Yaoundé.
   */
  coordinates: { lat: 3.848, lon: 11.502 },
  copyrightYear: 2026,
} as const

export const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Home', path: ROUTES.home, icon: 'house' },
  { label: 'About', path: ROUTES.about, icon: 'user' },
  { label: 'Expertise', path: ROUTES.services, icon: 'stack' },
  { label: 'Work', path: ROUTES.projects, icon: 'briefcase' },
  { label: 'Research', path: ROUTES.research, icon: 'flask' },
  { label: 'Contact', path: ROUTES.contact, icon: 'paperPlane' },
]

export const SOCIAL_LINKS: readonly SocialLink[] = [
  { label: 'GitHub', href: 'https://github.com/KrisEllaDavid', icon: 'github' },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/kris-david-steeve-ella',
    icon: 'linkedin',
  },
  { label: 'X', href: 'https://x.com/EllaKris10', icon: 'x' },
]

export const CONTACT_CHANNELS: readonly ContactChannel[] = [
  {
    label: 'Email',
    value: 'ellakrisdavidsteeve@gmail.com',
    href: 'mailto:ellakrisdavidsteeve@gmail.com',
  },
  { label: 'Phone', value: '(+237) 693 647 116', href: 'tel:+237693647116' },
  { label: 'Phone', value: '(+237) 683 724 003', href: 'tel:+237683724003' },
  { label: 'Based in', value: 'Nkoulou — Awae Escalier, Yaoundé, Cameroon' },
]

/** Spoken languages, listed on the about page. */
export const LANGUAGES: readonly string[] = ['English', 'French', 'Bulu']
